<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <b-alert variant="danger" :show="notify_less_than_three_days">
      Please contact Service Delivery on 5223 1925 for any leave requirements
      that fall within the following 5 Day period. This includes next day sick
      leave
    </b-alert>
    <div v-if="isManager || isPayroll || isAdministrator">
      <b-list-group horizontal v-if="!$v.item.$model._new">
        <b-list-group-item
          v-for="custom_label in custom_labels"
          :key="custom_label.text"
          >&nbsp;
          {{ custom_label.text }}
          <div class="box-label" :style="custom_label.background_color"></div>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div v-if="isManager || isPayroll || isAdministrator" class="mb-3">
      <full-calendar
        v-if="!$v.item.$model._new"
        ref="fullCalendar"
        :options="calendarOptions"
        :key="calendarOptions.random"
      >
      </full-calendar>
    </div>
    <o-widget-wrapper
      :schema="schema"
      name="staff_member"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        flat
        clearable
        v-model="item.staff_member"
        :items="optionEmployeeItems"
        text-field="full_name"
        value-field="id"
        :validator="$v.item[schema.fields.staff_member.name]"
        :loading="optionEmployeeWorking"
        name="staff_member"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.staff_member"
        :form-state="formState"
        :readonly="!isFastTrackLeaveGroupMember"
      ></o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="leave_type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <leave-request-type-form-card
        v-model="item.leave_type"
        :validators="$v.item.leave_type"
        :form-state="formState"
        :label="schema.fields.leave_type.label"
        :level="level + 1"
        :server-errors="_se.leave_type"
        :is-locked="item.id !== undefined"
        :employee-id="item.staff_member"
        @start_date_less_than_3_days="handleLessThanThreeDays($event)"
      >
      </leave-request-type-form-card>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="comments"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-area
        v-model="item.comments"
        :form-state="formState"
        name="comments"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.comments"
        :readonly="comments_readonly"
      ></o-text-area>
    </o-widget-wrapper>

    <o-form-group v-if="item.id" :label="schema.fields.status.label" id="status">
      <b-form-input disabled :value="status"></b-form-input>
    </o-form-group>

    <o-widget-wrapper
      :schema="schema"
      name="document"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-file-input
        v-model="item.document"
        show-preview
        :form-state="formState"
        :other-id="item.id"
        other-name="leave_request"
        name="document"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.document"
      ></o-file-input>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="tasks"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
      v-if="item.id"
    >
      <!--leave-request-task-form-table
        v-model="item.tasks"
        :validators="$v.item.tasks"
        :form-state="formState"
        :label="schema.fields.tasks.label"
        :level="level + 1"
        :server-errors="_se.tasks"
      >
      </leave-request-task-form-table-->
      <leave-request-task-form-card
        v-model="item.tasks"
        :validators="$v.item.tasks"
        :form-state="formState"
        :label="schema.fields.tasks.label"
        :level="level + 1"
        :server-errors="_se.tasks"
        :cancel="cancel"
        :is-currentuser-owner="isOwner"
      >
      </leave-request-task-form-card>
    </o-widget-wrapper>

    <!-- Cancel Button -->
    <o-form-group v-if="show_cancel_button" id="cancel_button">
      <b-button
        :variant="cancelButtonVariant"
        class="cancel-button"
        @click="cancelRequest()"
        :disabled="disableCancelButton"
        >{{ cancel_button_text }}</b-button
      >
    </o-form-group>

    <b-modal id="confirm-cancel-modal" hide-footer>
      <template #modal-title> Confirm </template>
      <div class="d-block text-center">
        <h5>Are you sure you want to cancel this request?</h5>
      </div>
      <b-button variant="danger" class="mt-3" block @click="cancelRequest()"
        >CANCEL REQUEST</b-button
      >
    </b-modal>
  </o-form-wrapper>
</template>

<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import interactionPlugin from "@fullcalendar/interaction";
import _ from "lodash";

import { ACTION_TYPES } from "../../../vue-ocom/store/store_keys";
import moment from "moment";

import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OTextArea from "../../../vue-ocom/components/forms/fields/OTextarea";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

// import { default as UserForm } from '../../user/components/ItemForm';
import { default as LeaveRequestTypeFormCard } from "../../leave_request_type/components/ItemFormCards";
import { default as LeaveRequestTaskFormTable } from "../../leave_request_task/components/ItemFormTable";
import { default as LeaveRequestTaskFormCard } from "../../leave_request_task/components/ItemFormCards";
import ODateButton from "../../../vue-ocom/components/forms/fields/ODateButton";
import OSpeedSelect from "../../../vue-ocom/components/forms/fields/OSpeedSelect";
import UserMixin from "../../mixins/UserMixin";
import { mapGetters, mapMutations, mapActions } from "vuex";
import * as CONFIG from "../../../config.js";

import * as LEAVE_TASK_STATUS from "../../leave_task_status.js";
import * as LEAVE_STATUS from "../../leave_status.js";
import * as LEAVE_TASK_TYPES from "@/app/leave_task_types";
import CodeOptionsFetchMixin from "@/vue-ocom/mixins/CodeOptionsFetchMixin.js";
import { is_item_active } from "@/vue-ocom/utils/active";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("LeaveRequest"),
    CreateCodeTableFetchMixin([
      "Employee",
      "EmployeeManager",
      "CodeLeaveType",
      "CodeDepot",
      "LeaveLimit",
      "BlockOutDate",
    ]),
    UserMixin,
    CodeOptionsFetchMixin("CurrentLeave", "LeaveRequest", function () {
      if (!this.item && this.item.id) {
        return null;
      }
      return this.leave_request_options;
    }),
  ],
  components: {
    FullCalendar,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OTextArea,
    ODateButton,
    OSpeedSelect,

    LeaveRequestTypeFormCard,
    LeaveRequestTaskFormTable,
    LeaveRequestTaskFormCard,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
    notificationShown: { type: Boolean, default: false },
    blockedStartDate: { type: String, default: "" },
    blockedEndDate: { type: String, default: "" },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.LeaveRequest, {}),
    custom_labels: [
      {
        text: "Current Item",
        background_color: { "background-color": "#A7C7E7" },
      },
      {
        text: "Approved",
        background_color: { "background-color": "#C1E1C1" },
      },
      {
        text: "Pending",
        background_color: { "background-color": "#FFFAA0" },
      },
      {
        text: "Block Out",
        background_color: { "background-color": "#FAA0A0" },
      },
    ],

    depot_over_the_limit: false,
    leave_type_over_the_limit: false,

    cancel: false,

    notify_less_than_three_days: false,
  }),
  methods: {
    ...mapMutations(["showMessage"]),
    ...mapActions("BlockOutDateModule", {
      blockedOutDate_getAll: ACTION_TYPES.GET_ALL,
    }),
    cancelRequest() {
      // this.item.cancelled = new Date();
      this.cancel = !this.cancel;
    },
    handleLessThanThreeDays(isLessThanThreeDays) {
      if (this.isFastTrackLeaveGroupMember) {
        this.notify_less_than_three_days = false;
      } else {
        this.notify_less_than_three_days = isLessThanThreeDays;

        // If the user is isFastTrackLeaveGroupMember then they can cancel anytime
        // so do not hide the create/update button!
        if (!this.isFastTrackLeaveGroupMember) {
          this.$emit("hideCreateButton", isLessThanThreeDays);
        }
      }
    },
  },
  computed: {
    ...mapGetters("AuthModule", ["currentUser"]),
    ...mapGetters("BlockOutDateModule", {
      blockOutDate_items: "items",
    }),
    ...mapGetters("AuthModule", ["currentUser"]),
    /**
     * Determines whether the comments field should be read-only based on the state of the item
     * and various conditions such as ownership, fast-track leave group membership, and other
     * restrictions.
     *
     * @return {boolean} True if the comments field should be read-only, false otherwise.
     */
    comments_readonly() {
      var isCreate = !this.item.id;
      var notOwner = !this.isOwner;
      var isFastTrackLeaveGroupMember = this.isFastTrackLeaveGroupMember;
      var makeFieldsReadonly = this.makeFieldsReadonly;

      if (isCreate) {
        if (isFastTrackLeaveGroupMember) {
          return false; // We can put in a comment as we are creating it for them.
        }
      }

      return notOwner || makeFieldsReadonly || !isCreate;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    cancel_button_text() {
      if (this.item.cancelled) return "Cancelled";
      else return "Cancel Leave Request";
    },
    date_range() {
      if (this.item && this.item.id) {
        var min_start_date = null;
        var max_end_date = null;
        const leave_type = this.item.leave_type;

        if (leave_type.length === 1) {
          min_start_date = moment(leave_type[0]["start_date"])
            .subtract(7, "days")
            .format("YYYY-MM-DD")
            .toString();
          max_end_date = moment(leave_type[0]["end_date"])
            .add(7, "days")
            .format("YYYY-MM-DD")
            .toString();
        } else if (leave_type.length > 1) {
          min_start_date = moment(leave_type[0]["start_date"])
            .subtract(7, "days")
            .format("YYYY-MM-DD")
            .toString();
          max_end_date = moment(leave_type[leave_type.length - 1]["end_date"])
            .add(7, "days")
            .format("YYYY-MM-DD")
            .toString();
        }

        return [min_start_date, max_end_date];
      }
      return null;
    },
    leave_request_options() {
      if (this.item && this.item.id) {
        var date_range = this.date_range;

        if (date_range) {
          return {
            filter: "one_week",
            when_start_date: date_range[0],
            when_end_date: date_range[1],
            offset: 0,
            limit: 10000,
            sort: "id",
            order: "asc",
            _code: true, // expects to be in Code field
          };
        }
      }
      return null;
    },
    status() {
      // For reference:
      // status 0 = New (Pending)
      // status 1 = Approved by Manager (Pending)
      // status 2 = Rejected by Manager
      // status 3 = Approved by Payroll
      // status 4 = Rejected by Payroll
      // status 5 = Cancelled but needs approval from Manager
      // status 6 = Cancelled (cancellation was approved by Manager)
      // status 7 = Cancelled (cancellation was rejected by Manager)

      if (this.item.status === LEAVE_STATUS.PENDING) return "Pending";
      if (this.item.status === LEAVE_STATUS.MANAGER_APPROVE) return "Pending";
      if (this.item.status === LEAVE_STATUS.MANAGER_REJECT) return "Rejected";
      if (this.item.status === LEAVE_STATUS.PAYROLL_APPROVE) return "Approved";
      if (this.item.status === LEAVE_STATUS.PAYROLL_REJECTED) return "Rejected";
      if (this.item.status === LEAVE_STATUS.CANCEL_PENDING)
        return "Cancelled (Pending)";
      if (this.item.status === LEAVE_STATUS.CANCEL_APPROVED)
        return "Cancelled (Approved)";
      if (this.item.status === LEAVE_STATUS.CANCEL_REJECTED)
        return "Cancelled (Rejected)";
    },
    duration() {
      if (this.date_range) {
        return (
          moment(this.date_range[1]).diff(moment(this.date_range[0]), "days") +
          7
        );
      }
      return 1;
    },
    initialDate() {
      var result = new Date();

      if (this.date_range) {
        result = new Date(this.date_range[0]);
      }
      return result;
    },
    calendarOptions() {
      if (this.blockOutDate_items && this.optionCurrentLeaveItems) {
        let employees = [];
        let records = [];
        let blocked_dates = [];
        let event_list = [];
        const vm = this;

        // Blocked dates
        if (this.blockOutDate_items.length > 0) {
          _.map(this.blockOutDate_items, function (item) {
            blocked_dates.push({
              description: item.description,
              start_date: item.start_date,
              end_date: item.end_date,
            });
          });

          var blockedId = this.blockOutDate_items[0]["id"] - 1;
          employees.push({
            id: blockedId,
            staff_name: "Blocked",
            staff_type: " Blocked",
          });
          blocked_dates.forEach((item) => {
            records.push({
              id: blockedId,
              staff_type: " Blocked",
              staff_name: "Blocked",
              start_date: item.start_date,
              end_date: item.end_date,
              part_of_day: 0,
              leave_type_description: item.description,
              blocked_color: "#FAA0A0",
            });
          });
        }

        // Leave requests
        _.map(this.optionCurrentLeaveItems, function (item) {
          employees.push({
            id: item.staff_member,
            staff_name: item.staff_name,
            staff_type: item.staff_type,
          });
          records.push(item);
        });

        _.map(records, function (item) {
          let start_date = moment(item["start_date"])
            .format("YYYY-MM-DD")
            .toString();
          let end_date = moment(item["end_date"])
            .format("YYYY-MM-DD")
            .toString();

          let colour =
            item.status === LEAVE_STATUS.PAYROLL_APPROVE
              ? "#C1E1C1"
              : "#FFFAA0";
          if (item.blocked_color) colour = item.blocked_color;
          colour = item.id == vm.item.id ? "#A7C7E7" : colour;
          // let display_text = ["", "Full", "Morning", "Afternoon", "Partial"];
          // console.log(display_text[item.part_of_day]);

          var resource_id = null;
          if (item.staff_member !== undefined) resource_id = item.staff_member;
          else resource_id = blockedId;

          event_list.push({
            resourceId: resource_id,
            color: colour,
            start: new Date(start_date),
            end: new Date(end_date),
            textColor: "black",
            title: `${start_date} - ${end_date}`,
          });
        });

        return {
          headerToolbar: {
            left: "title",
            center: "",
            right: "",
          },
          plugins: [resourceTimelinePlugin, interactionPlugin],
          themeSystem: "bootstrap",
          refetchResourcesOnNavigate: true,
          // eventRemove: this.eventRemove,
          selectable: true,
          displayEventTime: false,
          droppable: true, // this allows things to be dropped onto the calendar
          aspectRatio: 1,
          dayMaxEvents: true,
          height: 600,
          initialDate: this.initialDate,
          initialView: "timeline3Months",
          views: {
            timeline3Months: {
              type: "resourceTimeline",
              slotDuration: { days: 1 },
              duration: {
                days: this.duration,
              },
            },
          },
          schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
          resourceAreaColumns: [
            {
              headerContent: "Name",
              field: "staff_name",
            },
            {
              headerContent: "Type",
              field: "staff_type",
              group: true,
            },
          ],
          resourceOrder: "staff_type",
          resources: employees,
          events: event_list,
          random: Math.random(), // will cause error "unknown option" but is used as the key to trigger update
        };
      }
    },
    makeFieldsReadonly() {
      if (this.item.tasks) {
        // Make all fields readonly if:
        if (this.item.tasks[0].status !== LEAVE_TASK_STATUS.PENDING) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    currentDate() {
      // Edit screen:
      if (this.item.id) return "";
      else return moment().format("YYYY-MM-DD").toString();
    },
    isDateTimeReadonly() {
      if (this.item.id) return true;
      else return false;
    },
    disableCancelButton() {
      if (this.item.cancelled !== null) return true;
      else return false;
    },
    cancelButtonVariant() {
      let cancel_approval_task = this.item["tasks"].find(
        (task) => task.task_type === LEAVE_TASK_TYPES.CANCEL_APPROVAL
      );

      if (cancel_approval_task !== undefined) return "danger";
      else return "outline-danger";
    },
    show_cancel_button() {
      // Show cancel button if:
      // item.status === 0 (New)
      // item.status === 1 (Approved by manager)
      // item.status === 3 (Approved by payroll)

      // Don't show cancel button if:
      // cancel_approval_task.id already exists
      // item.status === 2 (Rejected by manager)
      // item.status === 4 (Rejected by payroll)
      // item.status === 5 (Cancelled - pending)
      // item.status === 6 (Cancelled - approved)
      // item.status === 7 (Cancelled - rejected)

      // Show cancel button to all managers
      if (this.isManager) {
        return true;
      }

      if (this.item["tasks"]) {
        let cancel_approval_task = this.item["tasks"].find(
          (task) => task.task_type === LEAVE_TASK_TYPES.CANCEL_APPROVAL
        );
        let cancel_id = null;

        if (cancel_approval_task)
          cancel_id =
            cancel_approval_task.id === undefined
              ? null
              : cancel_approval_task.id;

        if (
          this.item.id &&
          this.isOwner &&
          !cancel_id &&
          (this.item.status === LEAVE_STATUS.PENDING ||
            this.item.status === LEAVE_STATUS.MANAGER_APPROVE ||
            this.item.status === LEAVE_STATUS.PAYROLL_APPROVE)
        )
          return true;
      }

      return false;
    },
    isFastTrackLeaveGroupMember() {
      var result = false;

      if (this.currentUser.groups) {
        this.currentUser.groups.forEach(function (group) {
          if (group.name === "Fast Track Leave") result = true;
        });
      }

      return result;
    },
  },
  created() {
    var blocked_date_options = { limit: 10000 };
    this.blockedOutDate_getAll(blocked_date_options);
  },
};
</script>

<style>
.box-label {
  float: left;
  height: 20px;
  width: 20px;
  border: 1px solid black;
  clear: both;
}

.cancel-button {
  margin-top: 2%;
}
</style>
